import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fa3ce064&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fa3ce064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3ce064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa3ce064')) {
      api.createRecord('fa3ce064', component.options)
    } else {
      api.reload('fa3ce064', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fa3ce064&scoped=true&", function () {
      api.rerender('fa3ce064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/news/index.vue"
export default component.exports